








import { Component, Vue, Prop } from "vue-property-decorator";
import { FocusedTask } from "@/data/models/Task";
import { ButtonState } from "@/components/common/StateButton.vue";

@Component
export default class DragAppointmentComponent extends Vue {
  @Prop()
  task!: FocusedTask;

  @Prop()
  editEnabled!: boolean;

  get buttonState() {
    return this.editEnabled ? ButtonState.RED : ButtonState.DISABLED;
  }

  image!: HTMLElement;

  onDragStart(event: DragEvent, dragImage: HTMLElement) {
    const dataTransfer = event.dataTransfer;

    if (dataTransfer) {
      dataTransfer.effectAllowed = "move";

      const item = {
        id: this.task.id,
        content: this.task.id,
        task: this.task,
      };

      dataTransfer.setDragImage(dragImage, 0, 0);
      dataTransfer.setData("text", JSON.stringify(item));
    }
  }

  onAddAppointment() {
    this.$emit("addAppointment");
  }

  mounted() {
    const element = document.getElementById(this.task.id);
    const image = document.createElement("img");
    image.src =
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAABgAAAAYADwa0LPAAAA9klEQVRo3u2ZwQ6CMBBER+PV+ANyxl/XmHj24B8ZEuoH1AN4kADadmVaMy/piVJmWHaXtIDgsoq4xxusYbbe2vqNLI0MsPlk4ADgAsCh+1b9yByfOKbWc/2z61hzFYDGQGDqaHotwZwzEP8apymRcyXLAdjGhs8YB2AXasAjL0a1/n0Vyh4ZYFO8gU3A3NS/zlC+qoLFR0AG2ITkwBDrTh2VY8VHQAbYpOTA0n1hlOIjIANsGH3ANHeKj4AMsFEfYCMDbGSAzVwVeuB9c5e5V9pOXZiLwI0oeMg15qYaeRxw3AHsY51X6A4XWoLwFsAxRbwQQvyeJxE8qrBG9SADAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDIyLTA5LTA3VDEzOjQ2OjI1KzAwOjAwjGlsfQAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyMi0wOS0wN1QxMzo0NjoyNSswMDowMP001MEAAAAASUVORK5CYII=";

    if (element) {
      element.addEventListener(
        "dragstart",
        (event) => {
          this.onDragStart(event, image);
        },
        false
      );
    }
  }
}
